module.exports = __webpack_public_path__ + "img/Networking.160177ca.png";